module.exports = __webpack_public_path__ + "img/icon_ig.5cd740f6.png";